/* istanbul ignore file */
export var IntegrityEvent;
(function (IntegrityEvent) {
    IntegrityEvent["IntegrityCheckCompleted"] = "IntegrityCheckCompleted";
})(IntegrityEvent || (IntegrityEvent = {}));
